import React from 'react'
import { ErrorMessage } from 'formik'
import ErrorRow from './ErrorRow'
import classNames from 'classnames'

/**
 *
 * @param {object} field
 * @description contain { onChange, onBlur, name, value }
 * @link https://jaredpalmer.com/formik/docs/api/useField#fieldinputpropsvalue
 *
 * @param {object} meta
 * @description contain { value, touched, error, initialValue }
 * @link https://jaredpalmer.com/formik/docs/api/useField#fieldmetapropsvalue
 *
 * @param {object} form
 *
 */
export const Textarea = ({
    field,
    form,
    label,
    children,
    customError: ErrorComponent,
    errorMessagePosition,
    withoutMargin,
    groupClassName,
    absolutError = false,
    ...props
}) => {
    const { name } = field;
    const { disabled = false } = props;
    const isValid = !(form.errors[name] && form.touched[name]);

    return (
        <div className={classNames(
            "form-group", 
            groupClassName, 
            errorMessagePosition && `error-position-${errorMessagePosition}`, 
            { 
                'form-error': !isValid, 
                'form-disabled': disabled, 
                'without-margin': withoutMargin,
                'absolut-error': absolutError
            }
        )}>
            <div className={classNames("form-info")}>
                <label htmlFor={name}>{label}</label>
                {ErrorComponent ?
                    <ErrorComponent /> :
                    <ErrorMessage name={name} component={ErrorRow} />}
            </div>
            <div className="form-input">
                <textarea {...field} {...props} />
            </div>
        </div>
    );
};
